// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"a51113c1","261":"7deb869d","740":"4da78e2b","888":"d806d880","899":"03f47e4f","930":"53a963e0"}[chunkId] + ".chunk.css";
};